<template>
  <wrld-box :headerTitle="$t('fleet.properties')">
    <template v-slot:boxContent>
      <v-container class="pa-4">
        <v-row>
          <v-col class="text-right">
            <span class="subheading">
              <strong>{{$t('fleet.vehicle_dimensions')}}</strong>
            </span>
          </v-col>
          <v-col offset-sm="1">
            <span class="subheading">{{vehicleProperties.vehicle_dimensions | dimensionValue}} CM</span>
          </v-col>
          <v-col class="text-right">
            <span class="subheading">
              <strong>{{$t('fleet.vehicle_max_weight')}}</strong>
            </span>
          </v-col>
          <v-col offset-sm="1">
            <span class="subheading">3500 KG</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-right">
            <span class="subheading">
              <strong>{{$t('fleet.case_dimensions')}}</strong>
            </span>
          </v-col>
          <v-col offset-sm="1">
            <span class="subheading">{{vehicleProperties.case_dimensions | dimensionValue}} CM</span>
          </v-col>
          <v-col class="text-right">
            <span class="subheading">
              <strong>{{$t('fleet.case_max_weight')}}</strong>
            </span>
          </v-col>
          <v-col offset-sm="1">
            <span class="subheading">{{vehicleProperties.case_max_weight}} KG</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-right">
            <span class="subheading">
              <strong>{{$t('fleet.roof_dimensions')}}</strong>
            </span>
          </v-col>
          <v-col offset-sm="1">
            <span class="subheading">{{vehicleProperties.roof_dimensions | dimensionValue}} CM</span>
          </v-col>
          <v-col class="text-right">
            <span class="subheading">
              <strong>{{$t('fleet.roof_max_weight')}}</strong>
            </span>
          </v-col>
          <v-col offset-sm="1">
            <span class="subheading">{{vehicleProperties.roof_max_weight}} KG</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-right">
            <span class="subheading">
              <strong>{{$t('fleet.trailer_dimensions')}}</strong>
            </span>
          </v-col>
          <v-col offset-sm="1">
            <span class="subheading">{{vehicleProperties.trailer_dimensions | dimensionValue}} CM</span>
          </v-col>
          <v-col class="text-right">
            <span class="subheading">
              <strong>{{$t('fleet.trailer_max_weight')}}</strong>
            </span>
          </v-col>
          <v-col offset-sm="1">
            <span class="subheading">{{vehicleProperties.trailer_max_weight}} KG</span>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </wrld-box>
</template>

<script>
export default {
  name: 'VehicleDetailProperties',
  props: {
    vehicleProperties: Object
  }
}
</script>
